import React from "react";

const RIcon = ({ style, height }) => (
  <svg
    height={height}
    style={style}
    viewBox="0 0 66 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_2136_23141)">
      <rect
        x="2.29639"
        y="0.589355"
        width="63.3704"
        height="59"
        rx="7.18683"
        fill="#EFF1F5"
      />
      <rect
        x="2.92523"
        y="1.2182"
        width="62.1127"
        height="57.7423"
        rx="6.55798"
        stroke="#212326"
        strokeWidth="1.2577"
      />
    </g>
    <path
      d="M19.4611 33.7004V18.4424H22.4089V33.7004H19.4611ZM28.7197 33.7004L24.0697 27.099H27.3704L32.1658 33.7004H28.7197ZM21.537 28.6352V26.2479H25.3983C25.938 26.2479 26.4016 26.1371 26.7891 25.9157C27.1905 25.6943 27.5019 25.3829 27.7233 24.9815C27.9447 24.5802 28.0554 24.1235 28.0554 23.6114C28.0554 23.0855 27.9447 22.6219 27.7233 22.2206C27.5019 21.8192 27.1905 21.5078 26.7891 21.2864C26.4016 21.065 25.938 20.9543 25.3983 20.9543H21.537V18.4424H25.0869C26.3047 18.4424 27.3565 18.6223 28.2423 18.9821C29.1418 19.342 29.8338 19.8886 30.3182 20.6221C30.8026 21.3556 31.0448 22.2759 31.0448 23.3831V23.7152C31.0448 24.8362 30.7957 25.7566 30.2974 26.4762C29.8131 27.1959 29.128 27.7356 28.2423 28.0954C27.3565 28.4553 26.3047 28.6352 25.0869 28.6352H21.537Z"
      fill="#42464C"
    />
    <defs>
      <filter
        id="filter0_d_2136_23141"
        x="0.176757"
        y="0.589355"
        width="65.49"
        height="63.3704"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-2.11963" dy="4.37037" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.258824 0 0 0 0 0.27451 0 0 0 0 0.298039 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_2136_23141"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_2136_23141"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
export default RIcon;
